import { useLocation } from 'react-router-dom';

export const useGetTestId = (name = ''): string => {
  const { pathname } = useLocation();
  const [testIdPrefix] = pathname?.slice(1)?.split('/');

  return `${testIdPrefix?.slice(0, -1)}-${name}`;
};
